import React from "react";
import WorksTable from "./worksPage/WorksTable";
import useWorksPageController from "./worksPage/useWorksPageController";

function WorksPage() {
  const { t, loading, isUser, workList, handleRowClick, handleDeleteWork } = useWorksPageController();

  return (
    <div className="works-page">
      <div className="container works-page-content">
        <h1 className="mb-3">{t("worksTitle")}</h1>
        <WorksTable
          isUser={isUser}
          t={t}
          workList={workList}
          loading={loading}
          handleRowClick={handleRowClick}
          handleDeleteWork={handleDeleteWork}
        />
      </div>
    </div>
  );
}

export default WorksPage;
